import copy from "copy-text-to-clipboard";

const isClipboardAvailable = () => {
  return Object.prototype.hasOwnProperty.call(window, "ClipboardItem");
};

export const copyToClipboard = (text, onSuccess, onError) => {
  if (!navigator?.clipboard) {
    const isSuccess = copy(text);
    if (isSuccess) {
      onSuccess?.();
    } else {
      onError?.();
    }
  } else {
    navigator.clipboard
      .writeText(text)
      .then(() => onSuccess?.())
      .catch(() => onError?.());
  }
};

export const copyToClipboardWithMimeType = (contentObj, onSuccess, onError) => {
  if (!isClipboardAvailable()) {
    copyToClipboard(contentObj.text, onSuccess, onError);
  } else {
    const clipboardItem = {
      "text/plain": new Blob([contentObj.text], { type: "text/plain" }),
      "text/html": new Blob([contentObj.html], { type: "text/html" }),
    };
    navigator?.clipboard
      ?.write([new ClipboardItem(clipboardItem)])
      .then(() => onSuccess?.())
      .catch(() => onError?.());
  }
};
